export const COUNTRIES = {
  "อเมริกาเหนือ": ["🇺🇸 USA", "🇨🇦 Canada", "🇲🇽 Mexico"],
  "ยุโรป (Schengen 27)": [
    "🇩🇪 Germany", "🇫🇷 France", "🇮🇹 Italy", "🇪🇸 Spain", "🇳🇱 Netherlands",
    "🇧🇪 Belgium", "🇦🇹 Austria", "🇨🇭 Switzerland", "🇸🇪 Sweden", "🇳🇴 Norway",
    "🇩🇰 Denmark", "🇫🇮 Finland", "🇵🇱 Poland", "🇨🇿 Czechia", "🇭🇺 Hungary",
    "🇵🇹 Portugal", "🇬🇷 Greece", "🇸🇰 Slovakia", "🇸🇮 Slovenia", "🇮🇪 Ireland",
    "🇱🇺 Luxembourg", "🇱🇹 Lithuania", "🇱🇻 Latvia", "🇪🇪 Estonia", "🇲🇹 Malta",
    "🇮🇸 Iceland", "🇱🇮 Liechtenstein", "🇨🇾 Cyprus",
  ],
  "สหราชอาณาจักร & ยุโรปอื่น": ["🇬🇧 UK", "🇷🇺 Russia", "🇹🇷 Turkey", "🇺🇦 Ukraine"],
  "เอเชีย": [
    "🇯🇵 Japan", "🇰🇷 Korea", "🇨🇳 China", "🇭🇰 Hong Kong", "🇹🇼 Taiwan",
    "🇸🇬 Singapore", "🇲🇾 Malaysia", "🇮🇩 Indonesia", "🇵🇭 Philippines",
    "🇻🇳 Vietnam", "🇮🇳 India", "🇵🇰 Pakistan", "🇧🇩 Bangladesh", "🇱🇰 Sri Lanka",
  ],
  "โอเชียเนีย": ["🇦🇺 Australia", "🇳🇿 New Zealand", "🇫🇯 Fiji"],
  "ตะวันออกกลาง": [
    "🇦🇪 UAE", "🇸🇦 Saudi Arabia", "🇶🇦 Qatar", "🇰🇼 Kuwait",
    "🇧🇭 Bahrain", "🇴🇲 Oman", "🇮🇱 Israel", "🇯🇴 Jordan", "🇮🇷 Iran",
  ],
  "แอฟริกา": ["🇿🇦 South Africa", "🇪🇬 Egypt", "🇲🇦 Morocco", "🇰🇪 Kenya", "🇳🇬 Nigeria"],
  "ลาตินอเมริกา": ["🇧🇷 Brazil", "🇦🇷 Argentina", "🇨🇱 Chile", "🇨🇴 Colombia", "🇵🇪 Peru"],
} as const;
